import moment from "moment";
import {mapWritableState} from "pinia";
import useStore from "../store";


const getCardType = (cardNumber) => {

  let first = cardNumber.charAt(0);

  switch (first){
    case '3':
      return 'AMEX';
    case '4':
      return 'VISA';
    case '5':
      return 'MASTERCARD';
  }

  return '';
}

const debounce = (mainFunction, delay) => {
  // Declare a variable called 'timer' to store the timer ID
  let timer;

  // Return an anonymous function that takes in any number of arguments
  return (...args) => {
    // Clear the previous timer to prevent the execution of 'mainFunction'
    console.log(timer)
    clearTimeout(timer);

    // Set a new timer that will execute 'mainFunction' after the specified delay
    timer = setTimeout(() => {
      mainFunction(...args);
    }, delay);
  };
};


/* eslint-disable max-len */
const creditCard = /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15})$/;
//var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3,6})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12,15}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
/* eslint-enable max-len */

const isCreditCard = (str) => {
  let sanitized = str.replace(/[- ]+/g, '');

  if (!creditCard.test(sanitized)) {
    return false;
  }

  let sum = 0;
  let digit;
  let tmpNum;
  let shouldDouble;

  for (let i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);

    if (shouldDouble) {
      tmpNum *= 2;

      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }

    shouldDouble = !shouldDouble;
  }

  return !!(sum % 10 === 0 ? sanitized : false);
}

const generateRandomString = (length, prefix = '') => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return prefix + result;
}



const convertToIcsDate = (date) => {
  return moment(date).format('YYYYMMDDTHHmmss');
}

const makeGoogleCalendarUrl = (date, summary, description = '') => {
  const start = convertToIcsDate(date.start);
  const end = convertToIcsDate(date.end);

  return `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(summary)}&dates=${start}/${end}&details=${encodeURIComponent(description)}&ctz=Australia/Perth`;
}

const isAndroid = () => {
  return /Android/i.test(navigator.userAgent);
}

const isEnabledFlag = (value) => {
  if (typeof value === "boolean") {
    return value;
  }

  return ["1", "true", "yes", "on"].includes(String(value ?? "").trim().toLowerCase());
}

const makeIcsFile = (date, summary, description = '') => {
  const value =
      "BEGIN:VCALENDAR\n" +
      "CALSCALE:GREGORIAN\n" +
      "METHOD:PUBLISH\n" +
      "PRODID:-//Test Cal//EN\n" +
      "VERSION:2.0\n" +
      "BEGIN:VEVENT\n" +
      "UID:test-1\n" +
      "DTSTART;TZID=Australia/Perth:" +
      convertToIcsDate(date.start) +
      "\n" +
      "DTEND;TZID=Australia/Perth:" +
      convertToIcsDate(date.end) +
      "\n" +
      "SUMMARY:" +
      summary +
      "\n" +
      "DESCRIPTION:" +
      description +
      "\n" +
      "END:VEVENT\n" +
      "END:VCALENDAR";


  const blob = new Blob([value], { type: "text/calendar;charset=utf-8" });

  const a = document.createElement('a');
  a.setAttribute('download', 'booking.ics');
  a.setAttribute('href', window.URL.createObjectURL(blob));
  a.click(); // EXECUTING CLICK EVENT WILL AUTO-DOWNLOAD THE FILE
}


const currentAttraction = (attraction) => {

  const store = useStore()

  if (!attraction){
    return false;
  }

  return store.attractions.find(a => a.id === this.item.attraction) ?? false
}

const resolveAttraction = (item) => {
  if (!item) {
    return null;
  }

  const store = useStore()

  if (item.attraction) {
    return store.attractions.find((current) => Number(current?.id) === Number(item.attraction)) ?? null;
  }

  if (item.productCode) {
    return store.attractions.find(
      (current) => current?.rezdy_retail_product_code === item.productCode
        || (current?.rezdy_product_options ?? []).some(
          (option) => option?.product === item.productCode
        )
    ) ?? null;
  }

  return null;
}

const resolveBookingItemTime = (item) =>
  item?.time ?? item?.startTimeLocal ?? item?.startTime ?? null;

const bookingItemConflictKey = (item, index = 0) => String(
  item?.id
  ?? item?.bookingItemId
  ?? item?.itemId
  ?? `${resolveAttraction(item)?.id ?? item?.productCode ?? 'item'}-${resolveBookingItemTime(item) ?? index}`
)

const bookingAttractionTitle = (item, attraction) => (
  item?.attractionTitle
  ?? attraction?.retail_title
  ?? attraction?.title
  ?? attraction?.name
  ?? item?.productName
  ?? 'Experience'
)

const formatTravelBuffer = (hours = 1) => {
  const parsedHours = parseFloat(hours);
  const totalMinutes = Math.max(1, Math.ceil((Number.isFinite(parsedHours) && parsedHours > 0 ? parsedHours : 1) * 60 / 5) * 5);
  const hourCount = Math.floor(totalMinutes / 60);
  const minuteCount = totalMinutes % 60;
  const parts = [];

  if (hourCount > 0) {
    parts.push(`${hourCount} ${hourCount === 1 ? 'hour' : 'hours'}`);
  }

  if (minuteCount > 0) {
    parts.push(`${minuteCount} ${minuteCount === 1 ? 'minute' : 'minutes'}`);
  }

  return parts.join(' ');
}

const bookingItemsTooCloseConflicts = (items = []) => {
  const conflicts = new Map();

  if (!Array.isArray(items) || items.length < 2) {
    return [];
  }

  for (const [itemIndex, item] of items.entries()) {
    const itemTime = resolveBookingItemTime(item);
    const attraction = resolveAttraction(item);

    if (!itemTime || !attraction?.distance || attraction.distance.length < 1) {
      continue;
    }

    for (const [compareIndex, compareItem] of items.entries()) {
      const compareAttraction = resolveAttraction(compareItem);

      if (compareIndex === itemIndex || compareAttraction?.id === attraction?.id) {
        continue;
      }

      const compareTime = resolveBookingItemTime(compareItem);

      if (!compareTime || !compareAttraction?.id) {
        continue;
      }

      const compareAttractionDistance = attraction.distance.find(
        (distance) => Number(distance?.attraction) === Number(compareAttraction.id)
      );

      const requiredHours = parseFloat(compareAttractionDistance?.hours ?? 1);

      if (Number.isFinite(requiredHours) && requiredHours === 0) {
        continue;
      }

      const from = moment(itemTime).subtract(
        Number.isFinite(requiredHours) && requiredHours > 0 ? requiredHours : 1,
        "hours"
      );
      const to = moment(itemTime).add(
        Number.isFinite(requiredHours) && requiredHours > 0 ? requiredHours : 1,
        "hours"
      );

      if (moment(compareTime).isBetween(from, to)) {
        const itemKey = bookingItemConflictKey(item, itemIndex);
        const compareItemKey = bookingItemConflictKey(compareItem, compareIndex);
        const pairKey = [
          attraction?.id ?? bookingAttractionTitle(item, attraction),
          compareAttraction?.id ?? bookingAttractionTitle(compareItem, compareAttraction),
        ].map(String).sort().join('::');
        const existingConflict = conflicts.get(pairKey);
        const itemKeys = Array.from(new Set([
          ...(existingConflict?.itemKeys ?? []),
          itemKey,
          compareItemKey,
        ]));

        if (!existingConflict || Number(existingConflict.hours) < requiredHours) {
          conflicts.set(pairKey, {
            key: pairKey,
            itemKeys,
            attraction,
            compareAttraction,
            attractionTitle: bookingAttractionTitle(item, attraction),
            compareAttractionTitle: bookingAttractionTitle(compareItem, compareAttraction),
            hours: Number.isFinite(requiredHours) && requiredHours > 0 ? requiredHours : 1,
          });
        } else {
          existingConflict.itemKeys = itemKeys;
        }
      }
    }
  }

  return Array.from(conflicts.values());
}

const bookingItemsTooCloseKeys = (items = []) => {
  const conflictKeys = new Set();

  bookingItemsTooCloseConflicts(items).forEach((conflict) => {
    conflict.itemKeys.forEach((key) => conflictKeys.add(key));
  });

  return Array.from(conflictKeys);
}

const bookingItemsAreTooClose = (items = []) => bookingItemsTooCloseKeys(items).length > 0

const bookingItemsTooCloseMessages = (items = []) => bookingItemsTooCloseConflicts(items).map((conflict) => (
  `Allow at least ${formatTravelBuffer(conflict.hours)} between ${conflict.attractionTitle} and ${conflict.compareAttractionTitle}.`
))

const trackBookingComplete = (booking) => {
    let items = booking.items.map((i) => {
      return {
        id: i.productCode,
        sku: i.productCode,
        name: i.productName.replaceAll(" ", ""),
        price: i.subtotal,
        quantity: i.totalQuantity,
      };
    });

    if (window?.fathom && booking?.totalAmount) {
      console.log('booking-complete', (booking.totalAmount * 100))
      window.fathom.trackEvent('booking-complete', {
        _value: (booking.totalAmount * 100), // Value is in cents
      });
    }

    if (window?.dataLayer){
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          transaction_id: booking.orderNumber,
          affiliation: "Checkout",
          value: parseFloat(booking.totalAmount.toFixed(2)),
          currency: "AUD",
          tax: 0,
          shipping: 0,
          items: items
        }
      });
    }
}

export {
  getCardType,
  debounce,
  isCreditCard,
  generateRandomString,
  makeIcsFile,
  makeGoogleCalendarUrl,
  isAndroid,
  isEnabledFlag,
  bookingItemConflictKey,
  bookingItemsAreTooClose,
  bookingItemsTooCloseConflicts,
  bookingItemsTooCloseKeys,
  bookingItemsTooCloseMessages,
  currentAttraction,
  trackBookingComplete,
}
